/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowParallelHIcon24Regular = forwardRef('ArrowParallelHIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.634 2.61a.75.75 0 0 1 1.06-1.06l3.928 3.927a2.156 2.156 0 0 1 0 3.05l-3.928 3.927a.75.75 0 1 1-1.06-1.06l3.641-3.642H4.5a.75.75 0 1 1 0-1.5h13.775L14.634 2.61Z" }),
        React.createElement("path", { d: "M9.362 12.61a.75.75 0 0 0-1.06-1.06l-3.928 3.927a2.156 2.156 0 0 0 0 3.049l3.928 3.927a.75.75 0 0 0 1.06-1.06L5.721 17.75h13.775a.75.75 0 1 0 0-1.5H5.721l3.641-3.641Z" })));
});
